/* eslint-disable no-unused-vars,no-confusing-arrow */
import { groupBy, cloneDeep } from 'lodash-es';
import { applyFilterConditions, getGuestFilterTitle } from '@/utils/utilityFunctions';

// TODO: Refactor in function interfaces system
// Utility functions
// # Guest entity
function guestHasExtraGuest(guestTotalExtraGuests) {
  return { extraGuestCount: guestTotalExtraGuests || 0 };
}
function guestHasCheckedInExtraGuest(guestCheckedInExtraGuests) {
  return { extraGuestCount: guestCheckedInExtraGuests || 0 };
}
function guestHasNonCheckedInExtraGuest(guestCheckedInExtraGuests, guestTotalExtraGuests) {
  return {
    extraGuestCount: guestHasExtraGuest(guestTotalExtraGuests).extraGuestCount
      - guestHasCheckedInExtraGuest(guestCheckedInExtraGuests).extraGuestCount,
  };
}

// Filter functions
// # Guest status
function conditionStatusMainGuest(guestStatus, filterStatus) {
  return { mainGuestCount: guestStatus === filterStatus ? 1 : 0 };
}
// Special condition: Main guest is checked-in, nonCheckedInExtra's have to be counted in attending
const conditionStatusExtraGuest = (guestStatus, filterStatus, guestCheckedInExtraGuests, guestTotalExtraGuests) => {
  if (filterStatus === 2) { // Status: 2 (Checked-in filter)
    return { extraGuestCount: guestHasCheckedInExtraGuest(guestCheckedInExtraGuests).extraGuestCount };
  }
  // Main guest status is not matching filter status
  if (!conditionStatusMainGuest(guestStatus, filterStatus).mainGuestCount) {
    if (guestStatus !== 2 || filterStatus !== 1) return { extraGuestCount: 0 };
  }

  return ({ // Status: 0, 1, 3, 4, 5
    extraGuestCount: guestHasNonCheckedInExtraGuest(guestCheckedInExtraGuests, guestTotalExtraGuests).extraGuestCount,
  });
};
function conditionStatusMainExtraGuest(guestStatus, filterStatus, guestCheckedInExtraGuests, guestTotalExtraGuests) {
  return {
    mainGuestCount: conditionStatusMainGuest(guestStatus, filterStatus).mainGuestCount,
    extraGuestCount: conditionStatusExtraGuest(guestStatus, filterStatus, guestCheckedInExtraGuests,
      guestTotalExtraGuests).extraGuestCount,
  };
}
// # Guest VIP
function conditionVIPMainGuest(guestIsVIP) {
  return { mainGuestCount: guestIsVIP ? 1 : 0, extraGuestCount: 0 };
}

// Custom condition functions
function conditionNoPhotoMainGuest(guestPhotoStoragePath) {
  return { mainGuestCount: !guestPhotoStoragePath ? 1 : 0, extraGuestCount: 0 };
}
function conditionNoEmailMainGuest(guestEmail) {
  return { mainGuestCount: !guestEmail ? 1 : 0, extraGuestCount: 0 };
}
function conditionGuestHasExtras(guestTotalExtraGuests) {
  return { mainGuestCount: guestTotalExtraGuests || 0, extraGuestCount: 0 };
}

const defaultGuestGroups = [{
  name: 'Guest status',
  iconClasses: ['fad', 'clipboard-list-check'],
}, {
  name: 'My lists',
  iconClasses: ['fad', 'clipboard-list'],
},
// {
//   name: 'My filters',
//   iconClasses: ['far', 'tasks'],
// },
];

const predefinedConditions = {
  'no-status-guest': {
    name: '- (No status) guests',
    condition: (guest) => conditionStatusMainExtraGuest(guest.status, 0, guest.checkedInExtraGuests,
      guest.totalExtraGuests),
  },
  'attending-guest': {
    name: 'Attending guests',
    condition: (guest) => conditionStatusMainExtraGuest(guest.status, 1, guest.checkedInExtraGuests,
      guest.totalExtraGuests),
  },
  'checked-in-guest': {
    name: 'Checked-in guests',
    condition: (guest) => conditionStatusMainExtraGuest(guest.status, 2, guest.checkedInExtraGuests,
      guest.totalExtraGuests),
  },
  'checked-out-guest': {
    name: 'Checked-out guests',
    condition: (guest) => conditionStatusMainExtraGuest(guest.status, 3, guest.checkedInExtraGuests,
      guest.totalExtraGuests),
  },
  'invited-guest': {
    name: 'Invited guests',
    condition: (guest) => conditionStatusMainExtraGuest(guest.status, 4, guest.checkedInExtraGuests,
      guest.totalExtraGuests),
  },
  'declined-guest': {
    name: 'Declined guests',
    condition: (guest) => conditionStatusMainExtraGuest(guest.status, 5, guest.checkedInExtraGuests,
      guest.totalExtraGuests),
  },
  'vip-guest': {
    name: 'VIP guests',
    condition: (guest) => conditionVIPMainGuest(guest.vip),
  },
  'no-photo-guest': {
    name: 'Guests without photo',
    condition: (guest) => conditionNoPhotoMainGuest(guest.photoStoragePath),
  },
  'no-email-guest': {
    name: 'Guests without Email',
    condition: (guest) => conditionNoEmailMainGuest(guest.email),
  },
  'guest-has-extras': {
    name: 'Guests with extra\'s',
    condition: (guest) => conditionGuestHasExtras(guest.totalExtraGuests),
  },
};

const defaultGuestFilters = [{
  name: getGuestFilterTitle({ property: 'status', value: 0 }),
  groupIndex: 0,
  conditions: ['no-status-guest'],
}, {
  name: getGuestFilterTitle({ property: 'status', value: 1 }),
  groupIndex: 0,
  conditions: ['attending-guest'],
}, {
  name: getGuestFilterTitle({ property: 'status', value: 2 }),
  groupIndex: 0,
  conditions: ['checked-in-guest'],
}, {
  name: getGuestFilterTitle({ property: 'status', value: 3 }),
  groupIndex: 0,
  conditions: ['checked-out-guest'],
},
// {
//   name: getGuestFilterTitle({ property: 'status', value: 4 }),
//   groupIndex: 0,
//   conditions: ['invited-guest'],
// }, {
//   name: getGuestFilterTitle({ property: 'status', value: 5 }),
//   groupIndex: 0,
//   conditions: ['declined-guest'],
// },
{
  name: getGuestFilterTitle({ property: 'vip' }),
  groupIndex: 1,
  conditions: ['vip-guest'],
},
//   {
//   name: 'No photo',
//   groupIndex: 2,
//   conditions: ['no-photo-guest'],
// }, {
//   name: 'VIP & No photo',
//   groupIndex: 2,
//   conditions: ['no-photo-guest', 'vip-guest'],
// }, {
//   name: 'No Email',
//   groupIndex: 2,
//   conditions: ['no-email-guest'],
// }, {
//   name: 'Guest with extra\'s',
//   groupIndex: 2,
//   conditions: ['guest-has-extras'],
// }
];

const applyFiltersToGuest = (selectedFilterGroupsEntries, filterGroupsTotal, filterConditions, guestData) => {
  const guestCounts = { mainGuest: 0, extraGuest: 0 };
  const guestIsFiltered = [];
  for (let i = 0; i < filterGroupsTotal; i += 1) guestIsFiltered.push(false);

  // Reset filtering options
  for (let i = 0; i < filterGroupsTotal; i += 1) guestIsFiltered[i] = false;
  guestCounts.mainGuest = 0;
  guestCounts.extraGuest = 0;

  selectedFilterGroupsEntries.forEach(([groupIndex, filters], index) => {
    for (let i = 0; i < filters.length; i += 1) {
      const filterConditionsResult = applyFilterConditions(filterConditions, filters[i], guestData);

      if (filterConditionsResult.mainGuest || filterConditionsResult.extraGuest) { // Filter is applying
        guestIsFiltered[index] = true;
        guestCounts.mainGuest = guestCounts.mainGuest || filterConditionsResult.mainGuest;
        guestCounts.extraGuest += filterConditionsResult.extraGuest;
      }
    }
  });

  // Add guest
  if ((filterGroupsTotal === 1 && guestIsFiltered[0])
    || (filterGroupsTotal > 1 && guestIsFiltered.every((f) => f))) {
    return {
      guestIsFiltered: true,
      guestCounts,
    };
  }

  return {
    guestIsFiltered: false,
    guestCounts: {
      mainGuest: 0,
      extraGuest: 0,
    },
  };
};

// Generate default guest counts
const defaultSelectedFilterIndexes = [];
const defaultGuestFilterCounts = defaultGuestFilters.map(() => ({ mainGuest: 0, extraGuest: 0 }));
// TODO: Investigate option to create custom conditions and show preset custom filters that make sense for our users

export default {
  namespaced: true,
  state: {
    filterConditions: predefinedConditions,
    filters: defaultGuestFilters,
    filterCounts: cloneDeep(defaultGuestFilterCounts.slice(0)),
    filterGroups: defaultGuestGroups,
    filteredGuests: [],
    filteredGuestsCounts: {
      mainGuest: 0,
      extraGuest: 0,
    },
    selectedFilterIndexes: defaultSelectedFilterIndexes.slice(0),
  },
  getters: {
    // filterIsSelected: state => state.selectedFilterIndexes.length !== 0, // TODO: Remove
    anyFilterIsSelected: (state) => state.selectedFilterIndexes.length !== 0,
    selectedFilterGroups: (state) => groupBy(state.filters
      .filter((filter, filterIndex) => state.selectedFilterIndexes.includes(filterIndex)), 'groupIndex'),
    filteredGuests: (state, getters, rootState) => {
      if (!getters.anyFilterIsSelected) { // No filter is selected
        return {
          guests: rootState.guest.guests,
          guestsCounts: rootState.guest.guestsCounts,
        };
      }

      return {
        guests: state.filteredGuests,
        guestsCounts: state.filteredGuestsCounts,
      };
    },
  },
  mutations: {
    RESET_GUEST_FILTER_STATE(state) {
      // state.filterGroups = defaultGuestGroups;
      // state.filters = defaultGuestFilters;
      state.filterCounts = cloneDeep(defaultGuestFilterCounts);
      state.filteredGuests = [];
      state.filteredGuestsCounts.mainGuest = 0;
      state.filteredGuestsCounts.extraGuest = 0;
      state.selectedFilterIndexes = defaultSelectedFilterIndexes.slice(0);
    },
    // ADD_FILTER(state, filter) { // TODO: Feature - Possibility to add custom filters
    //   state.filters.push(filter);
    // },
    // REMOVE_FILTER(state, filter) {
    //   state.filters.push(filter);
    // },
    SET_FILTER_COUNTS(state, filterCountModifiers) {
      filterCountModifiers.forEach((filterCounts, filterIndex) => {
        state.filterCounts[filterIndex].mainGuest += filterCounts.mainGuest;
        state.filterCounts[filterIndex].extraGuest += filterCounts.extraGuest;
      });
    },
    SET_FILTERED_GUESTS(state, filteredGuests) {
      state.filteredGuests = filteredGuests;
    },
    SET_FILTERED_GUESTS_COUNTS(state, filteredGuestsCounts) {
      state.filteredGuestsCounts = filteredGuestsCounts; // TODO: Check if it works
    },
    RESET_SELECTED_FILTER_INDEXES(state) {
      state.selectedFilterIndexes = [];
    },
    ADD_SELECTED_FILTER_INDEX(state, filterIndex) {
      state.selectedFilterIndexes.push(filterIndex);
    },
    REMOVE_SELECTED_FILTER_INDEX(state, filterIndex) {
      state.selectedFilterIndexes.splice(filterIndex, 1);
    },
  },
  actions: {
    resetGuestFilterState: ({ commit }) => {
      commit('RESET_GUEST_FILTER_STATE');
    },
    resetSelectedFilterIndexes: ({ commit }) => {
      commit('RESET_SELECTED_FILTER_INDEXES');
    },
    updateSelectedFilterIndexes: ({ state, commit, dispatch }, filterIndex) => {
      const isFilterIndexFound = state.selectedFilterIndexes
        .findIndex((selectedFilterIndex) => selectedFilterIndex === filterIndex);

      if (isFilterIndexFound === -1) { // Filter doesn't exist yet
        commit('ADD_SELECTED_FILTER_INDEX', filterIndex);
      } else {
        commit('REMOVE_SELECTED_FILTER_INDEX', isFilterIndexFound);
      }

      // Updating filtered guests if filter selection changed
      if (state.selectedFilterIndexes.length) {
        dispatch('updateFilteredGuests');
      } else { // Resetting filtered guests count
        commit('SET_FILTERED_GUESTS', []);
        commit('SET_FILTERED_GUESTS_COUNTS', { mainGuest: 0, extraGuest: 0 });
      }
    },
    updateFilteredGuests: ({
      state, rootState, commit, getters,
    }) => {
      // TODO: Update filtered guests on guests change, filters
      // console.log('# Filtering guests');
      const filteredGuests = [];
      const guestsCounts = { mainGuest: 0, extraGuest: 0 };
      const filterGroupsTotal = Object.keys(getters.selectedFilterGroups).length;
      const selectedFilterGroupsEntries = Object.entries(getters.selectedFilterGroups);

      rootState.guest.guests.forEach((guest) => {
        const {
          guestIsFiltered,
          guestCounts,
        } = applyFiltersToGuest(selectedFilterGroupsEntries, filterGroupsTotal, rootState.guest.filter.filterConditions,
          guest);

        // Add guest
        if (guestIsFiltered) {
          filteredGuests.push(guest);
          guestsCounts.mainGuest += guestCounts.mainGuest;
          guestsCounts.extraGuest += guestCounts.extraGuest;
        }
      });

      commit('SET_FILTERED_GUESTS', filteredGuests);
      commit('SET_FILTERED_GUESTS_COUNTS', guestsCounts);
    },
    updateFilterCounts: ({ state, commit }, filterCountModifiers) => {
      commit('SET_FILTER_COUNTS', filterCountModifiers);
    },
  },
};
